module.exports = __webpack_public_path__ + "static/media/90300-Bronze.a8de88db.png";